import React from 'react';

const MinimizeIcon = () => (
  <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ cursor: 'pointer' }}>
    <rect y="0.5" width="20" height="20" rx="4" fill="#EFF1F3" />
    <path fillRule="evenodd" clipRule="evenodd" d="M5 10.5C5 10.1548 5.27982 9.875 5.625 9.875H14.7917C15.1368 9.875 15.4167 10.1548 15.4167 10.5C15.4167 10.8452 15.1368 11.125 14.7917 11.125H5.625C5.27982 11.125 5 10.8452 5 10.5Z" fill="black" />
  </svg>
);

export default MinimizeIcon;
